var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('custom-modal', {
    attrs: {
      "id": "reset-password-request-modal",
      "size": "lg",
      "body-class": "reset-password-request-modal-body"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('custom-overlay', {
          attrs: {
            "loading": _vm.loading
          },
          scopedSlots: _vm._u([{
            key: "overlay-body",
            fn: function () {
              return [_c('div', {
                staticClass: "reset-password-container"
              }, [_c('div', {
                staticClass: "text-body text-center"
              }, [_c('img', {
                staticClass: "mb-4",
                attrs: {
                  "src": require("@/assets/forgot-password/lock-icon.svg")
                }
              }), _c('p', {
                staticClass: "text-header"
              }, [_vm._v(" " + _vm._s(_vm.$t('reset-password.header')) + " ")]), _c('p', [_vm._v(_vm._s(_vm.$t('reset-password.info')))])]), _c('reset-password-request-form', {
                staticClass: "reset-form",
                on: {
                  "submit": _vm.onSubmit
                }
              })], 1)];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }), _c('custom-modal', {
    attrs: {
      "id": "reset-password-request-modal-confirm"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          staticClass: "text-body text-center"
        }, [_c('img', {
          staticClass: "mt-3",
          attrs: {
            "src": require("@/assets/forgot-password/success-icon.svg")
          }
        }), _c('p', {
          staticClass: "success-text-header mt-4"
        }, [_vm._v(" " + _vm._s(_vm.$t('reset-password.header-success')) + " ")]), _c('b-button', {
          staticClass: "mt-4",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.closeSuccessModal
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('reset-password.ok')) + " ")])], 1)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }